import React, { ReactElement } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import TextField, { TextFieldProps } from '@material-ui/core/TextField'

const useStyles = makeStyles((theme) => ({
  input: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 0,
      },
      '&.Mui-focused': {
        '& .MuiInputBase-input': {
          borderColor: theme.palette.text.input,
        },
      },
      '&.Mui-error': {
        '& .MuiInputBase-input': {
          borderColor: theme.palette.error.main,
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.main,
        },
      },
      '&.Mui-disabled': {
        '& .MuiInputBase-input': {
          backgroundColor: theme.palette.background.light,
          borderColor: theme.palette.text.input,
        },
      },
    },
    '& .MuiInputBase-input': {
      padding: theme.spacing(3),
      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(3, 8),
      },
      height: '46px',
      boxSizing: 'border-box',
      borderRadius: theme.shape.borderRadius,
      border: `1px solid ${theme.palette.text.input}`,
      backgroundColor: theme.palette.background.main,
      appearance: 'none',
      ...theme.typography.input,
    },
    '& .Mui-focused': {
      '& .MuiInputBase-input': {
        borderStyle: 'dotted',
      },
    },
    '& .MuiInput-underline:after, & .MuiInput-underline:before': {
      display: 'none',
    },
  },
}))

export type SearchTextInputProps = React.HTMLProps<HTMLInputElement> &
  TextFieldProps & {
    className?: string | ''
    id: string
    error?: string | boolean | false
    type?: string | 'text'
  }

export default function SearchTextInput({
  className,
  id,
  type,
  ...props
}: SearchTextInputProps): ReactElement {
  const classes = useStyles()

  return (
    <TextField
      className={clsx(className, classes.input)}
      data-testid="input"
      id={id}
      type={type}
      {...props}
    />
  )
}
